import { useEffect, useState } from 'react'

import {
  SelectsForConstructorModel,
  BlockApplicationModel
} from '../../../domain/models'
import {
  fetchFactors,
  fetchSelectsForConstructor
} from '../../usecases/services'

import { dateToday, getUser } from '../../../presentation/utils'
import { TestCardPersonality } from '../../../presentation/components'
import ImportFileModalFactory from '../import-file-modal'

import { useAlert } from 'react-alert'
import { useModalBox } from '../../../presentation/contexts'
import { fetchUploads, saveBlock } from '../../usecases/Import-files'
type TestCardPersonalityProps = {
  dispatch: any
  onRemove: any
  constructor: BlockApplicationModel
  match: any
  disable: boolean
  setDisable: (param: boolean) => void
  cdAplicacao: number
}

const TestCardPersonalityFactory = ({
  dispatch,
  onRemove,
  constructor,
  match,
  disable,
  setDisable,
  cdAplicacao
}: TestCardPersonalityProps) => {
  const [data, setData] = useState<BlockApplicationModel>({
    ...constructor,
    resultadoTeste: { ...constructor.resultadoTeste }
  })
  const [selectsForConstructor, setSelectsForConstructor] = useState<
    SelectsForConstructorModel[]
  >([])
  const [optionsList, setOptionsList] = useState<any[]>()
  const alert = useAlert()
  const user = getUser()
  const { modalBox } = useModalBox()
  const handleImportClick = async () => {
    setDisable(true)
    const body = {
      ...(data.cdBlocoAplicacaoTeste && {
        cdBlocoAplicacaoTeste: data.cdBlocoAplicacaoTeste
      }),
      construto: {
        cdConstruto: data?.construto?.cdConstruto,
        categoriaConstruto: data?.construto?.categoriaConstruto,
        construto: data?.construto?.construto
      },
      resultadoTeste: {
        construto: data?.construto?.cdConstruto,
        customTeste: data?.resultadoTeste?.customTeste,
        teste: data?.resultadoTeste?.teste?.cdTeste
          ? {
              cdTeste: data?.resultadoTeste?.teste?.cdTeste
            }
          : undefined,
        incluirBloco: data?.resultadoTeste?.customTeste
          ? false
          : data?.resultadoTeste?.incluirBloco,
        numeroPontos: data?.resultadoTeste?.numeroPontos,
        percentil: data?.resultadoTeste?.percentil,
        resultado: data?.resultadoTeste?.resultado,
        observacao: data?.resultadoTeste?.observacao,
        data: data?.resultadoTeste?.data
          ? data?.resultadoTeste?.data
          : dateToday
      }
    }
    try {
      const response = await saveBlock(cdAplicacao).post(body)
      alert.show('Salvo', {
        type: 'success',
        timeout: 4000
      })
      setDisable(false)
      const uploads = await fetchUploads(response.cdBlocoAplicacaoTeste).load()
      setData((prev: any) => ({
        position: prev.position,
        ...response
      }))

      modalBox(
        <ImportFileModalFactory
          uploads={uploads}
          cdBloco={response.cdBlocoAplicacaoTeste}
          cdPsicologo={user.cdPsicologo}
        />,
        'Anexar arquivos e fotos'
      )
    } catch (error) {
      console.error(error)
      alert.show('Erro ao salvar o Teste', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  useEffect(() => {
    ;(async () => {
      const responseSelectsForFactors = await fetchFactors({
        id: match?.params?.idassessment
      }).load()
      const newOptionsList = responseSelectsForFactors.map((item: any) => {
        const newOptionsList = item.fatorResultados.map((item: any) => {
          return item.classificacao
        })
        return newOptionsList
      })

      setOptionsList(newOptionsList)
    })()
  }, [match?.params?.idassessment])

  useEffect(() => {
    ;(async () => {
      try {
        const responseSelectsForConstructor = await fetchSelectsForConstructor({
          idConstructo: constructor.construto.cdConstruto,
          idService: match?.params?.idassessment
        }).load()

        setSelectsForConstructor(responseSelectsForConstructor)
      } catch (error) {
        console.log(error)
      }
    })()
  }, [constructor, match?.params?.idassessment])

  const handleBlur = () => {
    dispatch({
      type: 'updateCard',
      data: data
    })
  }

  const cardData = [
    {
      label: 'Incluir na análise',
      component: 'Checkbox',
      isChecked: data?.resultadoTeste?.incluirBloco,
      wrapperClassName: 'checkbox',
      onBlur: handleBlur,
      onClick: () => {
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            incluirBloco: !data.resultadoTeste.incluirBloco
          }
        }))
      }
    },
    {
      onBlur: handleBlur,
      wrapperClassName: 'name',
      component: 'SelectInput',
      label: 'Nome*',
      hasTestSelectInput: true,
      labelColor: '#4F4F4F',
      name: 'name',
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            teste: { cdTeste: Number(e.target.value) }
          }
        })),
      value: data?.resultadoTeste?.teste?.cdTeste,
      defaultValue: data?.resultadoTeste?.teste?.cdTeste,
      options: selectsForConstructor?.map(
        (item: SelectsForConstructorModel) => {
          return { value: item?.cdTeste, label: item.nome }
        }
      )
    },
    {
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'results',
      labelColor: '#4F4F4F',
      label: 'Resultado',
      name: 'Resultado',
      value: data?.resultadoTeste?.resultado,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            resultado: e.target.value
          }
        })),
      options: selectsForConstructor
        ?.find((item) => item?.cdTeste === data?.resultadoTeste?.teste?.cdTeste)
        ?.classificacao?.map((el) => {
          return { value: el, label: el }
        })
    },
    {
      hasTestInput: true,
      component: 'Input',
      labelColor: '#4F4F4F',
      label: 'Data',
      name: 'Data',
      type: 'date',
      value: data?.resultadoTeste?.data || dateToday,
      onBlur: handleBlur,
      wrapperClassName: 'date',
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            data: e.target.value
          }
        }))
    },
    {
      component: 'SelectInput',
      wrapperClassName: 'general-control',
      label: 'Controle Geral',
      hasTestSelectInput: true,
      hasSelectOption: false,
      labelColor: '#4F4F4F',
      name: 'controleGeral',
      value: data?.resultadoTeste?.controleGeral,
      onBlur: handleBlur,
      options: optionsList
        ? optionsList[0].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            controleGeral: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[1].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'affectivity',
      labelColor: '#4F4F4F',
      label: 'Afetividade',
      name: 'afetividade',
      value: data?.resultadoTeste?.afetividade,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            afetividade: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[2].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'personality-organization',
      labelColor: '#4F4F4F',
      label: 'Organização da Personalidade',
      name: 'personalityOrganization',
      value: data?.resultadoTeste?.organizacaoDaPersonalidade,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            organizacaoDaPersonalidade: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[3].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'agressivity',
      labelColor: '#4F4F4F',
      label: 'Agressividade',
      name: 'agressivity',
      value: data?.resultadoTeste?.agressividade,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            agressividade: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[4].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'emotionality',
      labelColor: '#4F4F4F',
      label: 'Maturidade e Emotividade',
      name: 'emotionality',
      value: data?.resultadoTeste?.maturidadeEEmotividade,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            maturidadeEEmotividade: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[5].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'inpulsiviness',
      labelColor: '#4F4F4F',
      label: 'Impulsividade',
      name: 'impulsiveness',
      value: data?.resultadoTeste?.impulsividade,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            impulsividade: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[6].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'interpessonal-relationship',
      labelColor: '#4F4F4F',
      label: 'Relacionamento Interpessoal',
      name: 'interpersonalRelationship',
      value: data?.resultadoTeste?.relacionamentoInterpessoal,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            relacionamentoInterpessoal: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[7].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      component: 'SelectInput',
      hasTestSelectInput: true,
      hasSelectOption: false,
      wrapperClassName: 'vital-energy',
      labelColor: '#4F4F4F',
      label: 'Energia Vital/Produtividade',
      name: 'vitalEnergyProdutivity',
      value: data?.resultadoTeste?.energiaVitalProdutividade,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            energiaVitalProdutividade: e.target.value
          }
        }))
    },
    {
      options: optionsList
        ? optionsList[8].map((item: any) => {
            return {
              value: item,
              label: item
            }
          })
        : [],
      hasTestSelectInput: true,
      hasSelectOption: false,
      component: 'SelectInput',
      wrapperClassName: 'psychic',
      labelColor: '#4F4F4F',
      label: 'Alterações Psiquicas',
      name: 'psychicAlterations',
      value: data?.resultadoTeste?.alterecaoPsiquicas,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            alterecaoPsiquicas: e.target.value
          }
        }))
    },
    {
      hasTestTextarea: true,
      component: 'Textarea',
      labelColor: '#4F4F4F',
      label: 'Obs:',
      name: 'obs',
      placeholder: 'Descrição da observação',
      value: data?.resultadoTeste?.observacao,
      onBlur: handleBlur,
      onChange: (e: any) =>
        setData((prev: any) => ({
          ...prev,
          resultadoTeste: {
            ...prev.resultadoTeste,
            observacao: e.target.value
          }
        }))
    }
  ]

  return (
    <TestCardPersonality
      data={cardData}
      onRemove={onRemove}
      handleImportClick={handleImportClick}
      disable={disable}
    />
  )
}

export default TestCardPersonalityFactory
